import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Typography } from "@mui/material";

const CustomMessage = ({ ...props }) => {
  const message = props.message;
  return (
    <Typography
      sx={{
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        height: "100vh",
        color: "grey",
        fontSize: "1.5rem",
      }}
    >
      <HelpOutlineIcon sx={{ fontSize: "8rem", color: "#dfdfdf", mr: 2 }} />
      {message}
    </Typography>
  );
};

export default CustomMessage;
